// Logo du cabinet : grille 3 × 3 de tuiles arrondies, déclinée en gris
const TUILES = [
  ['#c3c8d0', '#959ba6', '#6b717c'],
  ['#959ba6', '#e4e7ec', '#727884'],
  ['#6e7480', '#656b76', '#c3c8d0'],
];

export default function Logo({ taille = 32, className }) {
  return (
    <svg
      className={className}
      width={taille}
      height={taille}
      viewBox="0 0 30 30"
      role="img"
      aria-label="SoftManage"
    >
      {TUILES.flatMap((ligne, y) =>
        ligne.map((couleur, x) => (
          <rect key={`${x}-${y}`} x={x * 10 + 0.75} y={y * 10 + 0.75} width="8.5" height="8.5" rx="2.4" fill={couleur} />
        ))
      )}
    </svg>
  );
}
